import { useState, useEffect } from 'react';
import { profileApi, type ContactRecord } from '@/services/api';

export default function ContactRecords() {
  const [data, setData] = useState<ContactRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const title = '联系记录';
  const emptyText = '暂无联系记录，发布供给或需求信息后将获得更多曝光';

  useEffect(() => {
    profileApi
      .contacts()
      .then((result) => {
        setData(result);
        setLoading(false);
      })
      .catch((err) => {
        setError(err instanceof Error ? err.message : '加载失败');
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="text-center py-12">
        <div className="w-8 h-8 mx-auto rounded-full border-2 border-primary-500 border-t-transparent animate-spin"></div>
        <p className="text-foreground-400 text-sm mt-3">加载中...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <p className="text-foreground-500 text-sm">{error}</p>
        <button
          onClick={() => window.location.reload()}
          className="mt-3 text-sm text-primary-600 hover:text-primary-700 cursor-pointer font-medium"
        >
          重新加载
        </button>
      </div>
    );
  }

  return (
    <div>
      <h3 className="font-heading text-lg font-bold text-foreground-900 mb-4">
        {title} ({data.length})
      </h3>

      {data.length === 0 ? (
        <p className="text-foreground-400 text-sm py-12 text-center">{emptyText}</p>
      ) : (
        <div className="space-y-3">
          {data.map((record) => (
            <div
              key={record.id}
              className="bg-background-50 border border-background-200 rounded-lg p-5"
            >
              <div className="flex items-start justify-between gap-4 mb-3">
                <div>
                  <p className="text-foreground-900 text-sm font-semibold">
                    {record.company}
                  </p>
                  <p className="text-foreground-500 text-xs mt-0.5">
                    联系人：{record.contactPerson} | {record.phone}
                  </p>
                </div>
                <span className="text-foreground-400 text-xs flex-shrink-0">{record.time}</span>
              </div>
              <div className="bg-background-100 rounded-md p-3">
                <p className="text-foreground-500 text-xs mb-1">
                  关联信息：{record.inquiryTarget}
                </p>
                <p className="text-foreground-600 text-sm">{record.note}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}